import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Col,
  Row,
  ControlLabel,
  ListGroup,
  ListGroupItem,
  Button,
} from "react-bootstrap";
import Card from "../../../components/Card/Card";
import TextFieldGroup from "../../../components/TextFieldGroup/TextFieldGroup.js";
import Loading from "../../../views/Loading";
import { Multiselect } from "multiselect-react-dropdown";
import {
  produccion,  
  ventas,
  compras, 
  autorizaciones,
  logistica,
  ReportesComponentsHome,
} from "../../../variables/constantesReportes";
import Swal from 'sweetalert2';  // Importa SweetAlert2
import { dominio } from "../../../routes_backend/routes.jsx";



// import { rutas } from "../../../routes_backend/routes";

class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      isLoading: false,
      nombre: "",
      apellido: "",
      email: "",
      cargo: "",
      CargoOrda: "",
      DocEntry: "",
      USER_CODE:"",
      USERID:"",
      U_UserId:"",

      showProduction: false,      
      showVentas: false,
      showCompras: false,
      showAutorizaciones: false,
      showLogistica: false,

      showReportesComponentsHome: false,

      listProduction: [],
      ListVentas: [],
      ListCompras: [],
      ListAutorizaciones: [],
      ListLogistica: [],

      ListReportesComponentsHome: [],

      data_org: [],
      DocEntryOrganigrama: "",

      showHome: false,
      CheckHome: false,
      CheckProduction: false,
      CheckVentas: false,
      CheckCompras: false,
      CheckAutorizaciones: false,
      CheckLogistica: false,
      CheckReportesComponentsHome: false,

      selectedValueProduction: [],
      selectedValueVentas: [],
      selectedValueCompras: [],
      selectedValueAutorizaciones: [],
      selectedValueLogistica: [],
      selectedValueReportesComponentsHome: [],

      codigo: "",
    };
    this.onChange = this.onChange.bind(this);
  }


  onChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  home = () => {
    this.setState({
      CheckHome: !this.state.CheckHome,
    });
    if (document.getElementById("home").checked) {
      this.setState({
        showHome: true,
      });
    } else {
      this.setState({
        showHome: false,
        ListReportesComponentsHome: [],
      });
    }
  };
  Producction = () => {
    this.setState({
      CheckProduction: !this.state.CheckProduction,
    });
    if (document.getElementById("production").checked === true) {
      this.setState({
        showProduction: true,
      });
    } else {
      this.setState({
        showProduction: false,
        listProduction: [],
      });
    }
  };

  Ventas = () => {
    this.setState({
      CheckVentas: !this.state.CheckVentas,
    });
    if (document.getElementById("ventas").checked === true) {
      this.setState({
        showVentas: true,
      });
    } else {
      this.setState({
        showVentas: false,
        ListVentas: [],
      });
    }
  };

  Compras = () => {
    this.setState({
      CheckCompras: !this.state.CheckCompras,
    });
    if (document.getElementById("compras").checked === true) {
      this.setState({
        showCompras: true,
      });
    } else {
      this.setState({
        showCompras: false,
        ListCompras: [],
      });
    }
  };

  Autorizaciones = () => {
    this.setState({
      CheckAutorizaciones: !this.state.CheckAutorizaciones,
    });
    if (document.getElementById("autorizaciones").checked === true) {
      this.setState({
        showAutorizaciones: true,
      });
    } else {
      this.setState({
        showAutorizaciones: false,
        ListAutorizaciones: [],
      });
    }
  };

  Logistica = () => {
    this.setState({
      CheckLogistica: !this.state.CheckLogistica,
    });
    if (document.getElementById("logistica").checked === true) {
      this.setState({
        showLogistica: true,
      });
    } else {
      this.setState({
        showLogistica: false,
        ListLogistica: [],
      });
    }
  };

  componentWillMount() {
    // this.get_data_organigrama();
    let data = this.props.details;
    var DocEntry = "";
    var USER_CODE = "";
    var USERID = "";
    var nombre = "";
    var U_UserId = "";
    var apellido = "";
    var email = "";
    var cargo = "";
    var codigo = "";
    var CargoOrda = "";

    var temp_groups;
    var temp_report;

    var CheckHome = "";
    var CheckProduction = "";
    var CheckVentas = "";
    var CheckCompras = "";
    var CheckAutorizaciones = "";
    var CheckLogistica = "";
    var CheckReportesComponentsHome = "";

    var showHome = false;
    var showProduction = false;
    var showVentas = false;
    var showCompras = false;
    var showAutorizaciones = false;
    var showLogistica = false;
    var showReportesComponentsHome = false;

    var selectedValueProduction = [];
    var selectedValueVentas = [];
    var selectedValueCompras = [];
    var selectedValueAutorizaciones = [];
    var selectedValueLogistica = [];
    var selectedValueReportesComponentsHome = [];

    data.forEach((element) => {
      DocEntry = element.DocEntry;
      USER_CODE = element.USER_CODE;
      USERID = element.USERID;
      U_UserId = element.U_UserId;
      nombre = element.U_Nombre;
      apellido = element.U_Apellido;
      email = element.U_email;
      cargo = element.U_Cargo;
      codigo = element.U_serCode;
      CargoOrda = element.U_CargoOrda !== null ? parseInt(element.U_CargoOrda) : "";

      temp_groups = JSON.parse(element.U_GrpReporte);
      temp_report = JSON.parse(element.U_RepId);
    });
    temp_groups.forEach((element_groups) => {
      if (element_groups === 1) {
        showHome = true;
        CheckHome = true;
        showReportesComponentsHome = true;
        CheckReportesComponentsHome = true;
      }
      if (element_groups === 2) {
        CheckProduction = true;
        showProduction = true;
      }      
      if (element_groups === 3) {
        CheckVentas = true;
        showVentas = true;
      }    
      if (element_groups === 11) {
        CheckCompras = true;
        showCompras = true;
      }    
      if (element_groups === 12) {
        CheckAutorizaciones = true;
        showAutorizaciones = true;
      }  
      if (element_groups === 13) {
        CheckLogistica = true;
        showLogistica = true;
      }  
    });
    temp_report.forEach((element) => {     
      produccion.forEach((res) => {
        if (element === parseInt(res.id)) {
          selectedValueProduction.push(res);
          
        }
      });
      ventas.forEach((res) => {
        if (element === parseInt(res.id)) {
          selectedValueVentas.push(res);
        }
      });      
      compras.forEach((res) => {
        if (element === parseInt(res.id)) {
          selectedValueCompras.push(res);
          
        }
      });   
      autorizaciones.forEach((res) => {
        if (element === parseInt(res.id)) {
          selectedValueAutorizaciones.push(res);
          
        }
      });  
      logistica.forEach((res) => {
        if (element === parseInt(res.id)) {
          selectedValueLogistica.push(res);
          
        }
      }); 
    });

    this.setState({
      DocEntry: DocEntry,
      USER_CODE: USER_CODE,
      USERID: USERID,
      nombre: nombre,
      U_UserId: U_UserId,
      apellido: apellido,
      email: email,
      cargo: cargo,
      codigo: codigo,
      CargoOrda: CargoOrda,

      CheckHome: CheckHome,
      CheckProduction: CheckProduction,
      CheckVentas: CheckVentas,
      CheckCompras: CheckCompras,
      CheckAutorizaciones: CheckAutorizaciones,
      CheckLogistica: CheckLogistica,
      CheckReportesComponentsHome: CheckReportesComponentsHome,

      showHome: showHome,
      showProduction: showProduction,
      showVentas: showVentas,
      showCompras: showCompras,
      showAutorizaciones: showAutorizaciones,
      showLogistica: showLogistica,
      showReportesComponentsHome: showReportesComponentsHome,

      listProduction: selectedValueProduction,
      ListVentas: selectedValueVentas,
      ListCompras: selectedValueCompras,
      ListAutorizaciones: selectedValueAutorizaciones,
      ListLogistica: selectedValueLogistica,
      ListReportesComponentsHome: selectedValueReportesComponentsHome,
    });
  }
  onSelectProduction = (selectedList, selectedItem) => {
    this.setState({
      listProduction: selectedList,
    });
  };
  onRemoveProduction = (selectedList, removedItem) => {
    this.setState({
      listProduction: selectedList,
    });
  };
  
  onSelectVentas = (selectedList, selectedItem) => {
    this.setState({
      ListVentas: selectedList,
    });
  };

  onSelectCompras = (selectedList, selectedItem) => {
    this.setState({
      ListCompras: selectedList,
    });
  };
  onRemoveCompras = (selectedList, removedItem) => {
    this.setState({
      ListCompras: selectedList,
    });
  };
  onSelectAutorizaciones = (selectedList, selectedItem) => {
    this.setState({
      ListAutorizaciones: selectedList,
    });
  };
  onRemoveAutorizaciones = (selectedList, removedItem) => {
    this.setState({
      ListAutorizaciones: selectedList,
    });
  };
  onSelectLogistica = (selectedList, selectedItem) => {
    this.setState({
      ListLogistica: selectedList,
    });
  };
  onRemoveLogistica = (selectedList, removedItem) => {
    this.setState({
      ListLogistica: selectedList,
    });
  };

  onSelectReportesComponentsHome = (selectedList, selectedItem) => {
    this.setState({
      ListReportesComponentsHome: selectedList,
    });
  };
  onRemoveReportesComponentsHome = (selectedList, removedItem) => {
    this.setState({
      ListReportesComponentsHome: selectedList,
    });
  };

  data = () => {
    const { DocEntry, USER_CODE, USERID, U_UserId, nombre, apellido, cargo, email } = this.state;

    const temp_listProduction = Object.entries(this.state.listProduction).length === 0;    
    const temp_ListVentas = Object.entries(this.state.ListVentas).length === 0;
    const temp_ListCompras = Object.entries(this.state.ListCompras).length === 0;
    const temp_ListAutorizaciones = Object.entries(this.state.ListAutorizaciones).length === 0;
    const temp_ListLogistica = Object.entries(this.state.ListLogistica).length === 0;
    

    if (nombre === "") {
      return this.setState({
        message: "Ingrese nombre",
      });
    }

    if (apellido === "") {
      return this.setState({
        message: "Ingrese Apellido",
      });
    }
    if (cargo === "") {
      return this.setState({
        message: "Ingrese cargo",
      });
    }
    // if (email === "") {
    //   return this.setState({
    //     message: "Ingrese correo electronico",
    //   });
    // }

    if (
      document.getElementById("production").checked === true &&
      temp_listProduction === true
    ) {
      return this.setState({
        message: "seleccione una vista para produccion",
      });
    }
    
    if (
      document.getElementById("ventas").checked === true &&
      temp_ListVentas === true
    ) {
      return this.setState({
        message: "seleccione una vista para Ventas",
      });
    }

    if (
      document.getElementById("compras").checked === true &&
      temp_ListCompras === true
    ) {
      return this.setState({
        message: "selecciones un reporte para Compras",
      });
    }

    if (
      document.getElementById("autorizaciones").checked === true &&
      temp_ListAutorizaciones === true
    ) {
      return this.setState({
        message: "selecciones un reporte para Autorizaciones",
      });
    }
    if (
      document.getElementById("logistica").checked === true &&
      temp_ListLogistica === true
    ) {
      return this.setState({
        message: "selecciones un reporte para Logistica",
      });
    }
 
    if (
      this.state.showProduction === false &&
      this.state.showVentas === false &&
      this.state.showCompras === false &&
      this.state.showAutorizaciones=== false &&
      this.state.showLogistica=== false &&
      this.state.showReportesComponentsHome === false
    ) {
      return this.setState({
        message: "seleccione un grupo de reporte",
      });
    }
    try {
      this.setState({
        message: "",
        isLoading: true,
      });
      const array_item_report = [];
      const array_groups_report = [];

      if (this.state.showHome === true) {
        array_groups_report.push(1);
        this.state.ListReportesComponentsHome.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }
      if (this.state.showHome === false) {
        array_groups_report.push(0);
      }

      if (temp_listProduction === false) {
        array_groups_report.push(2);
        this.state.listProduction.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }
      
      if (temp_ListVentas === false) {
        array_groups_report.push(3);

        this.state.ListVentas.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      if (temp_ListCompras === false) {
        array_groups_report.push(11);

        this.state.ListCompras.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      if (temp_ListAutorizaciones === false) {
        array_groups_report.push(12);

        this.state.ListAutorizaciones.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }
      if (temp_ListLogistica === false) {
        array_groups_report.push(13);

        this.state.ListLogistica.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      var username = "";
      var password = "";
      var User_Code = "";
      var User_Id = "";
      let token = localStorage.getItem("token"); 
      let token_Data = JSON.parse(token); 
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
          User_Code = element.user_code;
          User_Id = element.user_id;
        });
      }
 
      
      if (token_Data === null) {
        this.props.history.push("");
      }

     const response = fetch(`${dominio}/updateUsuarios`, {
       method: 'PATCH',
       headers: {
         'Content-Type': 'application/json',
       },
       body: JSON.stringify({ 
        DocEntry,
        USERID,
         username,
         password,
         USER_CODE,
         U_UserId,
         nombre,
         apellido,
         cargo,
         email,
         array_groups_report,
         array_item_report,
         User_Code,
         User_Id
       }),
     });
   
     response
       .then((res) => res.json(), )
       .then((data) => {
        console.log(data);
 
         if (data.success) {

           // const tableDetails = JSON.parse(data[0]);
           Swal.fire({
            icon: 'success',
            title: 'Exito',
            text: 'Usuario modificado correctamente'
          })

           this.setState({
            isLoading: false,
            message: "",
          });
           
           return;
           
           // console.log('TM Creado Exitosamente');          
          
         } else {
           console.error('Error en la solicitud:', data[0].message);

           const errorMessage = data[0].message;
          
           // Reemplaza el alert con SweetAlert2
           Swal.fire({
             icon: 'error',
             title: 'Error al actualizar usuario',
             text: errorMessage || 'Mensaje de error no disponible'
           })

         }
      
       })
       .catch((error) => {
         console.error('Error en la solicitud:', error);

         const errorMessage = error;
          
           // Reemplaza el alert con SweetAlert2
           Swal.fire({
             icon: 'error',
             title: 'Error en la solicitud',
             text: errorMessage || 'Mensaje de error no disponible'
           })
       });



    } catch (error) {
      this.setState({
        isLoading: false,
        message: "",
      });
    }
  };

  AllProduction = () => {
    this.setState({
      listProduction: produccion,
    });
  };
  
  AllVentas = () => {
    this.setState({
      ListVentas: ventas,
    });
  };
  AllCompras = () => {
    this.setState({
      ListCompras: compras,
    });
  };
  AllAutorizaciones = () => {
    this.setState({
      ListAutorizaciones: autorizaciones,
    });
  };
  AllLogistica = () => {
    this.setState({
      ListLogistica: logistica,
    });
  };
  AllReportesComponentsHome = () => {
    this.setState({
      ListReportesComponentsHome: ReportesComponentsHome,
    });
  };
  render() {
    const {
      // U_UserId,
      nombre,
      USER_CODE,
      apellido,
      // email,
      cargo,
      isLoading,
      message,
      
    } = this.state;
    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title=""
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div className="row">
                      <br />
                      <br />
                      <p>
                        <strong>INFORMACION DE USUARIO</strong>
                      </p>
                      <br />
                     
                      <br />
                      <div className="col-sm-3">
                        <ControlLabel>Usuario SAP</ControlLabel>
                        <TextFieldGroup
                          field="USER_CODE"
                          value={USER_CODE}
                          onChange={this.onChange}
                          autoComplete="USER_CODE"
                          placeholder={"USER_CODE"}
                          disabled = {true}  
                        />
                      </div>
                      <br />
                      
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <ControlLabel>Nombre</ControlLabel>
                        <TextFieldGroup
                          field="nombre"
                          value={nombre}
                          onChange={this.onChange}
                          autoComplete="nombre"
                          placeholder={"nombre"}
                        />
                      </div>
                      <div className="col-sm-3">
                        <ControlLabel>Apellido</ControlLabel>
                        <TextFieldGroup
                          field="apellido"
                          value={apellido}
                          onChange={this.onChange}
                          autoComplete="apellido"
                          placeholder={"apellido"}
                        />
                      </div>
                      {/* <div className="col-sm-3">
                        <ControlLabel>E-mail</ControlLabel>
                        <TextFieldGroup
                          field="email"
                          name="email"
                          type="email"
                          id="email"
                          value={email}
                          onChange={this.onChange}
                          autoComplete="email"
                          placeholder={"email"}
                        />
                      </div> */}
                      <div className="col-sm-3">
                        <ControlLabel>Cargo</ControlLabel>
                        <TextFieldGroup
                          field="cargo"
                          value={cargo}
                          onChange={this.onChange}
                          autoComplete="cargo"
                          placeholder={"cargo"}
                        />
                      </div>
                     
                    </div>
                    <div className="row">
                      <br />
                      <br />
                      <p>
                        <strong>Acceso a Vistas</strong>
                      </p>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="home"
                              name="home"
                              checked={this.state.CheckHome}
                              onChange={this.home}
                            />
                            <label htmlFor="home">&nbsp;&nbsp;Home</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>                    
                    </div>
                    <div className="row">                 
                    <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="production"
                              name="production"
                              checked={this.state.CheckProduction}
                              onChange={this.Producction}
                            />
                            <label htmlFor="production">
                              &nbsp;&nbsp;Produccion
                            </label>
                          </ListGroupItem>
                        </ListGroup>
                      </div> 
                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="ventas"
                              name="ventas"
                              onChange={this.Ventas}
                              checked={this.state.CheckVentas}
                            />
                            <label htmlFor="ventas">&nbsp;&nbsp;Ventas</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>
                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="compras"
                              name="compras"
                              onChange={this.Compras}
                              checked={this.state.CheckCompras}
                            />
                            <label htmlFor="compras">&nbsp;&nbsp;Compras</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>
                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="autorizaciones"
                              name="autorizaciones"
                              onChange={this.Autorizaciones}
                              checked={this.state.CheckAutorizaciones}
                            />
                            <label htmlFor="autorizaciones">&nbsp;&nbsp;Autorizacioness</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>
                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="logistica"
                              name="logistica"
                              onChange={this.Logistica}
                              checked={this.state.CheckLogistica}
                            />
                            <label htmlFor="logistica">&nbsp;&nbsp;Logisticas</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>
                     
                    </div>
                    <div className="row">
                    
                      
                     
                     
                    </div>
                    <div className="row">
                     
                    
                    </div>

                    <div className="row">
                      <br />
                      {this.state.showProduction === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Produccion</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllProduction}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={produccion}
                            selectedValues={this.state.listProduction}
                            onSelect={this.onSelectProduction}
                            onRemove={this.onRemoveProduction}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}                     
                      {this.state.showVentas === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Ventas</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllVentas}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={ventas}
                            selectedValues={this.state.ListVentas}
                            onSelect={this.onSelectVentas}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.showCompras === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Compras</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllCompras}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={compras}
                            selectedValues={this.state.ListCompras}
                            onSelect={this.onSelectCompras}
                            onRemove={this.onRemoveCompras}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}  
                        {this.state.showAutorizaciones === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Autorizaciones</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllAutorizaciones}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={autorizaciones}
                            selectedValues={this.state.ListAutorizaciones}
                            onSelect={this.onSelectAutorizaciones}
                            onRemove={this.onRemoveAutorizaciones}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}  
                      {this.state.showLogistica === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Logistica</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllLogistica}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={logistica}
                            selectedValues={this.state.ListLogistica}
                            onSelect={this.onSelectLogistica}
                            onRemove={this.onRemoveLogistica}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}  
                    </div>

                    <div className="row">
                      <br />
                     
                      
                    </div>

                    <div className="row">
                      <br />
                      
                     
                    </div>

                    <div className="row">
                      <br />
                    
                      
                    </div>

                    <div className="row">
                      <br />
                    
                    
                    </div>

                    <div className="row">
                      <br />
                    
                 
                    </div>

                    <div className="row">
                      <br />
                      <br />
                      <br />
                      <Button
                        bsStyle="primary"
                        bsSize="small"
                        active
                        onClick={this.data}
                      >
                        {" "}
                        ACTUALIZAR
                      </Button>
                      <p style={style.errorMessage}>{message}</p>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(UserDetails);
const style = {
  text: {
    textAlign: "center",
  },
  ColorCell: {
    textAlign: "center",
    backgroundColor: "#dddddd",
    border: "0px solid",
    color: "#000",
  },
  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
